import React, { useEffect, useState } from "react"
import styled from "styled-components"
import { withTranslation } from "gatsby-plugin-react-i18next"
import Field from "./Field"
import { Fields, Intro, SubmitButton, Title } from "./Styles"
import {
  checkExistingAccount,
  confirmEmail,
  getUserReferralCode,
  loginUser,
  setUserToken,
} from "../../../services/user/user"
import { FORGOT_PASSWORD_FORM } from "../../../context/form/formTypes"
import colors from "../../../styles/colors"
import fonts from "../../../styles/fonts"
import { isBrowser } from "../../../services/browser"
import { cvgTrack } from "../../../services/converge"

const StyledTitle = styled(Title)`
  text-align: center;
  margin-bottom: 24px;
`
const StyledIntro = styled(Intro)`
  margin: 0 auto 40px;
  padding-bottom: 3px;
  text-align: center;
`
const ErrorMessage = styled(StyledIntro)`
  color: #db3232;
  margin-bottom: 40px;
  margin-top: -30px;
`

const FieldContainer = styled.div`
  padding: ${props => props.first ? "0" : "40px 0 0"};
  input {
    padding-bottom: 8px;
  }
`

const StyledSubmitButton = styled(SubmitButton)`
  margin: ${props => props.updated ? "40px 0 32px" : "40px 0 0"};
`

const PasswordLink = styled.div`
  ${fonts.helveticaNeue};
  color: ${colors.grey};
  font-size: 8px;
  line-height: 1.25;
  text-align: center;
  margin-top: 8px;
  padding-bottom: 4px;

  button {
    cursor: pointer;
    background: transparent;
    ${fonts.helveticaNeue};
    color: ${colors.grey};
    font-size: 8px;
    line-height: 1.25;
    text-align: right;
    padding: 0;
    border: none;
    text-decoration: underline;
  }
`

const Login = ({ t, setContent }) => {
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  })
  const [updatedPassword, setUpdatedPassword] = useState(() => {
    if (isBrowser()) {
      if(window.location.search && window.location.search.includes("reset-password-token")){
        return true;
      }
    }
    return false
  });

  const [submitError, setSubmitError] = useState(null)
  const [errors, setErrors] = useState({
    email: "",
    password: ""
  })


  useEffect(() => {
    if(window.location.search && window.location.search.includes("email-confirmation")) {
      const parameters = window.location.search.split("&")
      const token = parameters[0].split("email-confirmation=")[1]
      const email = parameters[1].split("email=")[1]

      confirmEmail(email, token).then(res => {
        // console.log(res.data.success)
      })
      .catch(error => {
        // console.log(error)
        setSubmitError(t("account.form_submit_error"))
      })
    }
  }, [])

  const handleChange = (name, value) => {
    let updatedFormData = formData

    updatedFormData[name] = value
    setFormData(updatedFormData)
  }

  const validateForm = () => {
    let hasError = false
    const formFields = Object.keys(formData)
    const updatedErrors = {
      email: "",
      password: ""
    }

    formFields.forEach((formField) => {
      if (formData[formField].length === 0) {
        updatedErrors[formField] = t("account.form_empty_field_error")
        hasError = true;
      }
    })

    setErrors(updatedErrors)

    return hasError
  }

  const submitForm = async (e) => {
    e.preventDefault()
    setSubmitError(null)

    const hasError = validateForm()

    if (hasError) {
      return
    }

    try {
      const userToken = await loginUser(formData)

      if(userToken.data.status === "Incorrect email or password") {
        let updatedErrors = {
          email: t("account.form_wrong_field_error"),
          password: t("account.form_wrong_field_error"),
        }
        setErrors(updatedErrors)
        return
      }

      if(userToken.data.status === "Account not activated") {
        setSubmitError(t("account.login_not_activated"))
      }

      if(userToken.data.token) {
        cvgTrack({
          event: "Logged In",
          profileProperties: {$email: formData.email},
          aliases: formData.email ? [`urn:email:${formData.email}`] : [],
        })
        setUserToken(userToken.data.token)
        const codeResult = await getUserReferralCode()
        if(codeResult.data.code === null) {
          const isCustomer = await checkExistingAccount()
          if(isCustomer.status === 200 && isCustomer.data && isCustomer.data.isCustomer === true) {
            // const createdCode = await createUserReferralCode(userToken.data.token)
          }
        }

        if (isBrowser()) {
          let urlWithPrefix = process.env.WEBSITE_URL_WITH_PREFIX || process.env.WEBSITE_URL || ""
          if (urlWithPrefix.endsWith("/")){
            urlWithPrefix = urlWithPrefix.slice(0, urlWithPrefix.length-1)
          }
          window.location.href = `${urlWithPrefix}/account`
        }
      }

    } catch (error) {
      console.error(error)
      setSubmitError(t("account.form_submit_error"))
    }
  }

  const switchToPassword = (e) => {
    e.preventDefault()
    setContent(FORGOT_PASSWORD_FORM)
  }

  return (
    <form onSubmit={submitForm}>
      <StyledTitle >{updatedPassword ? t("account.updated_password_title") : t("account.login_title")}</StyledTitle>
      <StyledIntro>{updatedPassword ? t("account.updated_password_intro") : t("account.login_intro")}</StyledIntro>
      {submitError && (
        <ErrorMessage>{submitError}</ErrorMessage>
      )}
      <Fields>
        <FieldContainer first>
          <Field
            data={formData}
            name="email"
            placeholder={t("account.form_email_placeholder")}
            label={t("account.form_email_placeholder")}
            handleChange={handleChange}
            type="email"
            error={errors.email}
            isPopup
          />
        </FieldContainer>
        <FieldContainer>
          <Field
            data={formData}
            name="password"
            placeholder={t("account.form_password_placeholder")}
            handleChange={handleChange}
            type="password"
            error={errors.password}
            isPopup
          />
        </FieldContainer>
      </Fields>
      <StyledSubmitButton type="submit" updated={updatedPassword ? 1 : 0}>
        {t("account.login_submit")}
      </StyledSubmitButton>
      {!updatedPassword && <PasswordLink  i18nKey={"account.forgot_password_link"}>
        You forgot your password? No problem, <button type="button" onClick={switchToPassword}>reset your password here</button>
      </PasswordLink>}
    </form>
  )
}

export default withTranslation()(Login)
